export const resultsConfigurations = {
  refiner: 'vertical(sort=frequency/descending,filter=6/0/*)',
  RecentSearchClick: 'Recent Search Click',
  maxResultCount: 9999,
  resultsPerPage: [
    {
      vertical: 'All',
      count: 96
    },
    {
      vertical: 'Documents',
      count: 9600
    },
    {
      vertical: 'Credentials',
      count: 9600
    },
    {
      vertical: 'People',
      count: 96
    },
    {
      vertical: 'Videos',
      count: 9600
    },
    {
      vertical: 'Data',
      count: 9600
    }
  ]
};
